<div class="row page-header">
    <div class="col-12">
        <h1>Consumable/Tool Transfer Records <small>View the transfer records for small tools and consumable materials</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="false"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Transfer Records'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="73"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Id'" [binding]="'indexId'" [format]="'d'" [width]="100"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Transfer Date'"
                            [binding]="'date'"
                            [format]="'d'"
                            [width]="150"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Tool/Consumable'"
                            [binding]="'material'"
                            [dataMap]="materialMap"
                            [width]="'1.5*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Location'"
                            [binding]="'location'"
                            [dataMap]="locationMap"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Quantity'" [binding]="'quantity'" [width]="115"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Total Price'"
                            [binding]="'totalPrice'"
                            [format]="'C2'"
                            [width]="115"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Requested By'" [binding]="'requestedByName'" [width]="220"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'User'" [binding]="'userName'" [width]="220"></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
</div>
